module.exports = __webpack_public_path__ + "img/floatExplain.51ad0269.svg";